<template>
  <Modal class="max-w-[600px]!">
    <Modal.Title>Invite access</Modal.Title>
    <Modal.Body>
      <FileAccessBody :file="file" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import type { File } from '@/shared/graphql/router/graphql'
import FileAccessBody from './FileAccessBody.vue'

defineProps<{
  file: File
}>()
</script>
